import { SegmentedControlOption } from "@components/SegmentedControl";
import { SipFrequency, TrumpContributionFrequency } from "@ctypes";
import { Translations, i18n } from "@i18n";

export const trumpContributionFrequencyLabel: Record<TrumpContributionFrequency, string> = {
  [TrumpContributionFrequency.Weekly]: i18n.t(Translations.TrumpSidecarFrequencyWeekly),
  [TrumpContributionFrequency.BiWeekly]: i18n.t(Translations.TrumpSidecarFrequencyBiWeekly),
  [TrumpContributionFrequency.Monthly]: i18n.t(Translations.TrumpSidecarFrequencyMonthly),
  [TrumpContributionFrequency.Annually]: i18n.t(Translations.TrumpSidecarFrequencyAnnually),
};

export const trumpContributionFrequencyOptions: SegmentedControlOption[] = [
  TrumpContributionFrequency.Weekly,
  TrumpContributionFrequency.BiWeekly,
  TrumpContributionFrequency.Monthly,
  TrumpContributionFrequency.Annually,
].map((frequency) => ({
  key: frequency,
  label: trumpContributionFrequencyLabel[frequency],
}));

export const sidecarContributionFrequencyOptions: SegmentedControlOption[] = [
  {
    key: SipFrequency.Weekly,
    label: i18n.t(Translations.TrumpSidecarFrequencyWeekly),
  },
  {
    key: SipFrequency.Monthly,
    label: i18n.t(Translations.TrumpSidecarFrequencyMonthly),
  },
];
